//info cards
const addInfoCard = (position, type) => {
    const parentElement = document.getElementById("bc-sf-filter-products")
    const card = document.querySelector(`.info-card-${type + 1}`)
    const cardClone = card.cloneNode(true)
    parentElement.insertBefore(cardClone, document.querySelectorAll("#bc-sf-filter-products > div")[position]);
}
let lastPage = null
let firstTime = true
let added = Array(4).fill(false)
let addedCards = 0
const fillCards = (changeFill = false) => {
    const cards = document.querySelectorAll("#bc-sf-filter-products > div").length
    if (addedCards <= 4) {
        for (let i = 1; i < 5; i++) {
            if (cards >= (13 * i) && !added[0]) {
                //console.log("Added 1")
                addedCards++
            }
        }
        let lastNumber = null
        for (let i = 0; i < addedCards; i++) {
            if (!added[i]) {
                added[i] = true
                if(changeFill){
                    switch (i) {
                        case 0:
                            addInfoCard(12 * (i + 1), 4)
                            break
                        case 1:
                            addInfoCard(12 * (i + 1), 5)
                            break
                        case 2:
                        case 3:
                            let random = Math.round(Math.random() * 3)
                            if(lastNumber){
                                while(lastNumber === random){
                                    //console.log("%cnumber" + lastNumber +" "+ random, "font-size: 4rem;")
                                    random = Math.round(Math.random() * 3)
                                }
                            }else{
                                lastNumber = random
                            }
                            addInfoCard(12 * (i + 1), random)
                            break  
                    }
                }else{
                    addInfoCard(12 * (i + 1), i)
                }
            }
        }

    }
}
window.addEventListener("load", fillCards)

let observer = new MutationObserver(mutations => {
    const url = new URL(window.location.href);
    let isEven = false
    if (url.searchParams.has('page')) {
        if(url.searchParams.get('page') != lastPage){
            lastPage = url.searchParams.get('page')
            added = Array(4).fill(false)
            addedCards = 0
            if(url.searchParams.get('page') % 2 == 0){
                isEven = true
            }
        }
    }else if(lastPage != null) {
        lastPage = null
        added = Array(4).fill(false)
        addedCards = 0
    }
    fillCards(isEven)
    /* console.log("%cha mutado", "font-size: 4rem;") */
})

observer.observe(document.getElementById("bc-sf-filter-products"), {
    childList: true
})